import {
  Box,
  Center,
  Divider,
  Flex,
  Link,
  Spinner,
  Stack,
  Text,
} from '@chakra-ui/react';
import React from 'react';
import { Link as RouterLink, useParams } from 'react-router-dom';
import { Heading, StatusBadge } from '~/components';
import { ROUTER_PATHS } from '~/constants';
import { useCompany } from '~/hooks';
import { replaceParameters } from '~/utils/replaceParamaters';

export const CompanyDetails: React.VFC = () => {
  const { companyId } = useParams<{ companyId: string }>();
  const { data, isError, isLoading } = useCompany(Number(companyId));

  if (isLoading) return <Spinner />;

  return (
    <Box px="8" py="4">
      <Heading hasBackButton>
        Empresa - {data?.nm_razaosocial || data?.cnpjFormatado}
      </Heading>
      <Flex
        flexDir={{ md: 'row', sm: 'column' }}
        w="100%"
        py={9}
        gridGap="12"
        style={{
          position: 'relative',
        }}
      >
        <Stack maxW={400} w="100%" gridGap={2}>
          <Heading fontSize="md" mb={2}>
            Dados Gerais
          </Heading>
          <Flex justify="space-between" align="center">
            <Text fontWeight="medium" color="gray.800" fontSize="14px">
              Nome Fantasia:
            </Text>
            <Text color="gray.500" fontSize="14px">
              {data?.nm_fantasia || '-'}
            </Text>
          </Flex>
          <Flex justify="space-between" align="center">
            <Text fontWeight="medium" color="gray.800" fontSize="14px">
              Razão Social:
            </Text>
            <Text color="gray.500" fontSize="14px">
              {data?.nm_razaosocial || '-'}
            </Text>
          </Flex>
          <Flex justify="space-between" align="center">
            <Text fontWeight="medium" color="gray.800" fontSize="14px">
              CNPJ:
            </Text>
            <Text color="gray.500" fontSize="14px">
              {data?.cnpjFormatado}
            </Text>
          </Flex>
          <Flex justify="space-between" align="center">
            <Text fontWeight="medium" color="gray.800" fontSize="14px">
              Tipo:
            </Text>
            <Text color="gray.500" fontSize="14px">
              {data?.isHeadOffice ? 'Matriz' : 'Filial'}
            </Text>
          </Flex>
          <Flex justify="space-between" align="center">
            <Text fontWeight="medium" color="gray.800" fontSize="14px">
              Grupo Econômico:
            </Text>
            <Text color="gray.500" fontSize="14px">
              {data?.grupoeconomico?.nm_grupoeconomico || '-'}
            </Text>
          </Flex>
          {/* 
          <Flex justify="space-between" align="center">
            <Text fontWeight="medium" color="gray.800" fontSize="14px">
              É responsável por pagar a fatura?
            </Text>
            <Text color="gray.500" fontSize="14px">
              {data?.isInvoicePayer ? 'Sim' : 'Não'}
            </Text>
          </Flex> 
          */}
          <Flex justify="space-between" align="center">
            <Text fontWeight="medium" color="gray.800" fontSize="14px">
              E-mail de fatura:
            </Text>
            <Text color="gray.500" fontSize="14px">
              {data?.ds_emailfatura || '-'}
            </Text>
          </Flex>
          <Flex justify="space-between" align="center">
            <Text fontWeight="medium" color="gray.800" fontSize="14px">
              Status:
            </Text>
            <Text color="gray.500" fontSize="14px">
              <StatusBadge variant={data && data.status ? 'green' : 'red'}>
                {data?.isActive}
              </StatusBadge>
            </Text>
          </Flex>
          <Flex flexDir="column">
            {!data?.isHeadOffice && !!data?.id_empresamatriz && (
              <Link
                mt={8}
                as={RouterLink}
                to={replaceParameters(
                  ROUTER_PATHS.PORTAL.ADMIN.COMPANY_DETAIL,
                  String(data?.id_empresamatriz),
                )}
              >
                Ver detalhes da Matriz
              </Link>
            )}
          </Flex>
        </Stack>
        <Center
          position="relative"
          bottom="0"
          display={{ md: 'block', sm: 'none' }}
        >
          <Divider orientation="vertical" borderColor="gray.300" />
        </Center>
        <Stack maxW={400} w="100%" gridGap={2}>
          <Heading fontSize="md" mb={2}>
            Localização
          </Heading>
          <Flex justify="space-between" align="center">
            <Text fontWeight="medium" fontSize="14px" color="gray.800">
              Estado:
            </Text>
            <Text color="gray.500" fontSize="14px">
              {data?.estado?.sg_estado || '-'}
            </Text>
          </Flex>
          <Flex justify="space-between" align="center" fontSize="14px">
            <Text fontWeight="medium" color="gray.800">
              Cidade:
            </Text>
            <Text color="gray.500" fontSize="14px">
              {data?.nm_cidade}
            </Text>
          </Flex>
          <Flex justify="space-between" align="center" fontSize="14px">
            <Text fontWeight="medium" color="gray.800">
              Endereço:
            </Text>
            <Text color="gray.500" fontSize="14px">
              {`${data?.nm_endereco}, ${data?.nu_endereco}`}
            </Text>
          </Flex>
          <Flex justify="space-between" align="center" fontSize="14px">
            <Text fontWeight="medium" color="gray.800">
              Complemento:
            </Text>
            <Text color="gray.500" fontSize="14px">
              {data?.ds_complementoendereco || '-'}
            </Text>
          </Flex>
        </Stack>
      </Flex>
    </Box>
  );
};
